import useSWR from "swr";

import { type WorkflowListItem } from "../types";
import { simpleFetcher } from "../fetcher";
import { includesSearch } from "~/helpers/string";

const url = "/api/v2/workflows";

export const QueryParams = {
  Title: "searchTitle",
};

interface Params {
  titleSearch?: string | null;
}

export function useWorkflows({ titleSearch }: Params = {}) {
  const swr = useSWR<WorkflowListItem[], Error>(url, simpleFetcher);

  const filteredData = swr.data?.filter(
    (w) => !titleSearch || includesSearch(w.documentVersion.title, titleSearch),
  );

  return {
    data: filteredData,
    error: swr.error,
    mutate: swr.mutate,
    isLoading: swr.isLoading,
  };
}
